// src/environments/environment.ts
export const environment = {
    production: false,

    externalLinks: {
        unitOverview: 'https://unitoverview-ui-oasis-oasiszadev-mnng.scp.eu-central-1.aws.cloud.bmw?vin='
    }
};
export const AuthConfig = {
    AMBaseURL: 'https://emea.int.alpha.sso.bmwgroup.com/auth',
    realmPath: 'realms/root/realms/alpha',
    clientId: 'ffdd9ed3-f1b4-4887-b02f-6f8da8096a72',
    redirectUri: 'https://smsza-int.bmwgroup.com&authIndexValue=strongAuth4000Service&acr_values=strongAuth4000Service',
    state: 'myappstate',
    nonce: '123456789',
    scopes: 'openid%20profile%20email%20organization',
};
